export default "__VITE_ASSET__C5QYvv9E__"